import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { PerfilComponent } from "./perfil.component";
import { RouterModule } from "@angular/router";
import { FichaComponent } from "./components/ficha/ficha.component";
import { FuseSharedModule } from "@fuse/shared.module";
import { MatIconModule } from "@angular/material/icon";
import { MatListModule } from "@angular/material/list";
import { AuthGuard } from "@auth0/auth0-angular";
import { RolesComponent } from "./components/roles/roles.component";
import { DialogCambiarClaveComponent } from "./components/dialog-cambiar-clave/dialog-cambiar-clave.component";
import { DialogEditarPerfilComponent } from "./components/dialog-editar-perfil/dialog-editar-perfil.component";

import { MatDialogModule } from "@angular/material/dialog";
import { MatInputModule } from "@angular/material/input";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatButtonModule } from "@angular/material/button";
import { MatToolbarModule } from "@angular/material/toolbar";
import { NotificacionesComponent } from "./components/notificaciones/notificaciones.component";
import { MatTabsModule } from "@angular/material/tabs";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";

const routes = [
    {
        path: "perfil",
        component: PerfilComponent,
        canActivate: [AuthGuard],
    },
];

@NgModule({
    declarations: [
        PerfilComponent,
        FichaComponent,
        RolesComponent,
        DialogCambiarClaveComponent,
        DialogEditarPerfilComponent,
        NotificacionesComponent,
    ],
    imports: [
        CommonModule,
        RouterModule.forChild(routes),
        FuseSharedModule,
        MatIconModule,
        MatButtonModule,
        MatListModule,
        MatInputModule,
        MatFormFieldModule,
        MatDialogModule,
        MatToolbarModule,
        MatTabsModule,
        MatSlideToggleModule,
    ],
})
export class PerfilModule {}
